import {User} from "./User";
import {Product} from "./Product";
import {Opp} from "./Opp";
import {createModelSchema, list, object,} from 'serializr';

export class CurrentUser extends User {

   subaccounts = [];

   products: Array<Product> = [];

   opps = [];

}

createModelSchema(CurrentUser, {
    subaccounts: list(object(User)),
    products: list(object(Product)),
    opps: list(object(Opp)),
});
